import { makeStyles } from '@material-ui/core';

const colorWithOpacity = (color: string, opacity: number): string => {
  if (color.startsWith('rgb')) {
    const match = color.match(/[\d.]+/g);
    if (match && match.length >= 3) {
      return `rgba(${match[0]}, ${match[1]}, ${match[2]}, ${opacity})`;
    }
  }
  const hex = color.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default makeStyles(theme => ({
  clampedText: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  readMoreContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  readMoreButton: {
    padding: 0,
    textTransform: 'none',
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
    '&:hover': {
      background: 'transparent',
      textDecoration: 'underline',
    },
  },
  mandatoryChip: {
    marginLeft: `${theme.spacing(1)}px !important`,
    color: `${theme.palette.error.dark} !important`,
    borderColor: theme.palette.error.main,
    backgroundColor: `${theme.palette.error.light} !important`,
    verticalAlign: 'middle',
    cursor: 'default',
  },
  completedColor: {
    color: theme.palette.success.main,
  },
  inProgressColor: {
    color: theme.palette.warning.main,
  },
  notStartedColor: {
    color: theme.palette.grey[500],
  },
  notApplicableColor: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  statusSelect: {
    minWidth: 140,
  },
  stepCard: {
    borderRadius: 4,
    marginBottom: 16,
    padding: 16,
    transition: 'border-color 0.2s, box-shadow 0.2s',
    '&:focus-within': {
      outline: 'none',
    },
  },
  stepCardCompleted: {
    backgroundColor: colorWithOpacity(theme.palette.success.main, 0.05),
    border: '1px solid',
    borderColor: theme.palette.success.main,
    '&:focus-within': {
      boxShadow: `0 0 0 2px ${theme.palette.success.main}`,
    },
  },
  stepCardInProgress: {
    backgroundColor: colorWithOpacity(theme.palette.warning.main, 0.05),
    border: '1px solid',
    borderColor: theme.palette.warning.main,
    '&:focus-within': {
      boxShadow: `0 0 0 2px ${theme.palette.warning.main}`,
    },
  },
  stepCardNotStarted: {
    backgroundColor: colorWithOpacity(theme.palette.grey[500], 0.05),
    border: '1px solid',
    borderColor: theme.palette.grey[500],
    '&:focus-within': {
      boxShadow: `0 0 0 2px ${theme.palette.grey[500]}`,
    },
  },
  stepCardNotApplicable: {
    backgroundColor: colorWithOpacity(theme.palette.text.secondary, 0.05),
    border: '1px solid',
    borderColor: theme.palette.text.secondary,
    '&:focus-within': {
      boxShadow: `0 0 0 2px ${theme.palette.text.secondary}`,
    },
  },
}));
